module.exports = __webpack_public_path__ + "static/img/单点登录.431afe1a.png";